import { type RouteRecordRaw } from 'vue-router'

export const accountRoutesNew: RouteRecordRaw[] = [
  {
    path: '/account',
    component: () => import('layouts/receiver/MainLayout.vue'),
    redirect: '/account/profile',
    meta: {
      requiresAuth: true,
    },
    // Profile / Preferences / Security
    children: [
      {
        path: ':tabName',
        name: 'manage-account',
        component: () =>
          import('pages/receiver/account/loggedIn/AccountConfig.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/email-preferences/:token',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/receiver/account/EmailPreferences.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
]

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/account',
    component: () => import('layouts/receiver/MainLayout.vue'),
    redirect: '/account/profile',
    meta: {
      requiresAuth: false,
      menu: 'account',
    },

    children: [
      // Notifications
      {
        path: 'notifications',
        component: () =>
          import('pages/receiver/account/loggedIn/NotificationsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      // Security
      {
        path: 'security/close-account',
        component: () =>
          import('pages/receiver/account/loggedIn/CloseAccount.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      // PASSWORD CREATION
      {
        path: 'security/password-creation',
        component: () =>
          import('pages/receiver/account/security/PasswordCreationPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      // PASSWORD UPDATE
      {
        path: 'security/password-update',
        component: () =>
          import('pages/receiver/account/security/PasswordUpdatePage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      // EMAIL UPDATE
      {
        path: 'security/email-update',

        component: () =>
          import('pages/receiver/account/security/EmailUpdatePage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      // Organisation
      {
        path: 'organisations',
        component: () => import('pages/common/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'manage-organisations',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/ManageOrganisations.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ROLE_USER'],
            },
          },
          // Page
          {
            path: 'page',
            name: 'organisation-page-integration',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/PageIntegration.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_UPDATE_SETTINGS'],
            },
          },
          // Info
          {
            path: 'info',
            name: 'organisation-info',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/UpdateInfo.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_UPDATE_SETTINGS'],
            },
          },
          // Members
          {
            path: 'members',
            name: 'manage-organisation-members',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/members/ManageMembers.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_MEMBERS'],
            },
          },
          // Roles
          {
            path: 'roles',
            name: 'manage-organisation-roles',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/roles/ManageRoles.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_ROLES'],
            },
          },
        ],
      },
      // Billing
      {
        path: 'billing',
        redirect: '/account/billing/subscription',
        children: [
          {
            path: 'options/:subscriptionId',
            name: 'manage-billing-options',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/billing/ManageOptions.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_ACCOUNTING'],
            },
          },
          {
            path: ':tabName',
            name: 'manage-billing',
            component: () =>
              import(
                'pages/receiver/account/loggedIn/organisations/billing/BillingPage.vue'
              ),
            meta: {
              requiresAuth: true,
              roles: ['ORGANISATION_ACCOUNTING'],
            },
          },
        ],
      },
    ],
  },
]
